import { render, staticRenderFns } from "./IresDeviceName.vue?vue&type=template&id=08879fd6&scoped=true&"
import script from "./IresDeviceName.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceName.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceName.vue?vue&type=style&index=0&id=08879fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08879fd6",
  null
  
)

export default component.exports